<template>
	<div class="chat_preview">
      <div class="preview_msg">
        <div class="preview_msg_title">{{ preView.headerContent }}</div>
        <div class="preview_msg_body" v-html="bodyContent"></div>
        <div class="preview_msg_footer">{{ preView.footerContent }}</div>
        <div class="preview_button_action" v-show="preView.buttonList && preView.buttonList[0] && (preView.buttonList[0]['actionType'] == 2 || preView.buttonList[0]['actionType'] == 3)">
          <div class="button_action" v-for="(btn, index) in preView.buttonList" :key="index">
            <i class="iconfont icon-dianhua" v-show="btn['actionType'] == 3"></i>
            <i class="iconfont icon-zhuanfa" v-show="btn['actionType'] == 2"></i>
            <span>{{ btn.label }}</span>
          </div>
        </div>
      </div>
      <div class="preview_button_text" v-show="preView.buttonList && preView.buttonList[0] && preView.buttonList[0]['actionType'] == 1">
        <span v-for="(item, index) in preView.buttonList" :key="index" class="button_text"> {{ item.label }}</span>
      </div>
	</div>
</template>
<script>

export default {
	name: 'chatPreview',
	props: {
		placeholder: {
			type: String,
			default: '',
		},
		value: {
			type: Object,
			default: () => {},
		},
		width: {
			type: String,
			default: '100%',
		},
	},
  watch: {
    value: {
      handler(newValue) {
        this.preView = newValue;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    bodyContent() {
      let str = '';
      if(this.preView.bodyContent) {
        let b1 = this.preView.bodyContent.indexOf('*'); // 加粗
        let b2 = this.preView.bodyContent.lastIndexOf('*');
        let i1 = this.preView.bodyContent.indexOf('_');
        let i2 = this.preView.bodyContent.lastIndexOf('_'); // 倾斜

        str = this.preView.bodyContent;
        str = str.replace(/\n/g,'<br>'); // 替换所以回车为<br>标签

        if(b1 < i1) {
          // 如果b1在i1之前，说明最左外边是加粗
          str = str.replace('*', '<b>');
          
          if(b2 > i2) {
            // 如果b2在i2之后，说明最右外边是加粗
            str = str.replace(/\*(?!.*\*)/,'</b>');

            str = str.replace('_', '<i>'); // 加粗里面的倾斜
            str = str.replace(/_(?!.*_)/,'</i>'); // 加粗里面的倾斜
          }else {
            // 如果i2在b2之后，说明最右外边是倾斜
            str = str.replace(/_(?!.*_)/,'</i>'); // 最右边倾斜
            str = str.replace('_', '<i>'); // 加粗里面的倾斜

            if(b2 > i1) {
              // 如果加粗的最右边 > 倾斜的最左边
              str = str.replace(/\*(?!.*\*)/,'</i></b><i>'); // 最右边是倾斜，所以外侧多个<i>闭合标签
            }else {
              str = str.replace(/\*(?!.*\*)/,'</b>');
            }
          }
        }else if(b1 > i1) {
          // 如果b1在i1之后，说明左边是倾斜
          str = str.replace('_', '<i>');
          if(i2 > b2) {
            // 如果12在b2之后，说明最右外边是倾斜
            str = str.replace(/_(?!.*_)/,'</i>');

            str = str.replace('*', '<b>'); // 倾斜里面的加粗
            str = str.replace(/\*(?!.*\*)/,'</b>'); // 倾斜里面的加粗
          }else {
            // 如果b2在i2之后，说明最右外边是加粗
            str = str.replace(/\*(?!.*\*)/,'</b>'); // 最右边加粗
            str = str.replace('*', '<b>'); // 倾斜里面的加粗

            if(i2 > b1) {
              // 如果倾斜的最右边 > 加粗的最左边
              str = str.replace(/_(?!.*_)/,'</b></i><b>'); // 最右边是加粗，所以外侧多个<b>闭合标签
            }else {
              str = str.replace(/_(?!.*_)/,'</i>');
            }
          }
        }
        
        return str;
      }else {
        return ''
      }
    },
	},
	data() {
		return {
			preView: {
        buttonList: [
          {
            actionType: ''
          }
        ]
      },
		};
	},
};
</script>
<style lang="scss">
.chat_preview {
    .preview_msg {
        margin-bottom: 15px;
        .preview_msg_title {
            font-weight: 500;
            color: #253044;
            line-height: 22px;
            word-wrap: break-word;
        }
        .preview_msg_body {
            font-size: 12px;
            font-weight: 400;
            color: rgba(37,48,68,.84);
            line-height: 20px;
            word-wrap: break-word;
        }
        .preview_msg_footer {
            font-size: 12px;
            font-weight: 400;
            color: rgba(11,38,64,.43);
            line-height: 17px;
            word-wrap: break-word;
        }
        .preview_button_action {
            border-top: 1px solid #dadde1;
            margin: 0 7px 0 9px;
            .button_action {
                color: #00a5f4;
                font-size: 15px;
                line-height: 20px;
                padding: 5px 16px;
                white-space: pre-wrap;
                display: flex;
                align-items: center;
                justify-content: center;
                .icon-dianhua {
                    font-size: 16px;
                }
                .icon-zhuanfa {
                    font-size: 25px;
                }
            }
        }
    }
    .preview_button_text {
        margin-left: -2px;
        flex-wrap: wrap;
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        .button_text {
        background-color: #F9F9F9;
        border-radius: 7.5px;
        box-sizing: border-box;
        flex-grow: 1;
        margin: 2px 0 0 2px;
        min-width: calc(50% - 2px);
        color: #00a5f4;
        // height: 34px;
        font-weight: 400;
        color: #2c6bff;
        line-height: 35px;
        padding: 0 16px;
        white-space: pre-wrap;
        display: flex;
        align-items: center;
        justify-content: center;
        }
    }
}
</style>
